// !delete this file
import React from 'react';
import { Pane } from 'evergreen-ui';
import { NavLinkButton } from './NavLinkButton';

/**
 * Строчка кнопок-навигаций.
 *
 * Можно передать атрибуты для Pane для дополнительной стилизации
 * @param buttons Array[{
 *  to: string, label: string, iconBefore: icon_from_evergreen
 *  }]
 */
export const NavLinkButtons = React.memo(({ buttons = [], ...paneProps }) => (
  <Pane
    display="grid"
    gridAutoColumns="max-content"
    gridAutoFlow="column"
    justifySelf="end"
    gap=".2rem"
    paddingX="0.5rem"
    paddingTop="0.25rem"
    {...paneProps}
  >
    {
      buttons.map(({ to, label, iconBefore }) => (
        <NavLinkButton
          key={to}
          to={to}
          iconBefore={iconBefore}
        >
          {label}
        </NavLinkButton>

      ))
    }
  </Pane>
));
NavLinkButtons.displayName = 'NavLinkButtons';
